import styled, {css} from 'styled-components';
import { Fonts, Colors } from 'common/Theme';
import Helpers from 'common/Theme/Helpers';

export const WrapStyle = styled.div`
  ${Helpers.css.flex_no_shrink};
  ${Helpers.css.flex};
  ${Helpers.css.flex_vertical};
  background: #FFFFFF;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  margin-bottom: 13px;
  //margin-bottom
  ${props => props.mb && css`
      margin-bottom: ${Helpers.css.mb[props.mb]};
  `}
      //end margin-bottom

`;

export const ButtonWrapStyle = styled.div`
  padding: 8px 6px 6px;
`;

export const ImageWrapStyle = styled.div`
  ${Helpers.fullWidth};
  height: 165px;
  position: relative;
  overflow: hidden;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
`;

export const TextWrapStyle = styled.div`
  ${Helpers.css.flex};
  ${Helpers.css.flex_vertical};
  ${Helpers.css.flex_sb};
  ${Helpers.css.flex_grow};
  padding: 8px 10px 0;
`;

export const WrapMiniStyle = styled.div`
  ${Helpers.css.flex_no_shrink};
  ${Helpers.css.flex_ac};
  ${Helpers.css.flex_sb};
  ${Helpers.css.flex};
  background: #FFFFFF;
  height: 70px;
  width: 200px;
  border: 1px solid rgba(0, 0, 0, 0.04);
  border-radius: 15px;
  padding: 8px 10px 6px;
  margin-right: 28px;
  position: relative;
`;

export const TextWrapMiniStyle = styled.div`
  ${Helpers.css.flex};
  ${Helpers.css.flex_vertical};
  ${Helpers.css.flex_sb};
  ${Helpers.css.flex_grow};
  height: 100%;
`;

export const ImageWrapMiniStyle = styled.div`
  height: 50px;
  width: 50px;
  border-radius: 5px;
  position: relative;
  overflow: hidden;
`;

export const ButtonMiniStyle = styled.div`
  ${Helpers.css.item_vertical};
  right: -14px;
`;



export const WrapSmallStyle = styled.div`
  //height: 247px;
  border-radius: 16px;
  display: block;
  overflow: hidden;
  position: relative;
  ${Helpers.css.flex_no_shrink};

  //margin-bottom
  ${props => props.mb && css`
      margin-bottom: ${Helpers.css.mb[props.mb]};
  `}
  //end margin-bottom

  ${props => props.isClose && css`
    &:after{
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 5;
    }
  `}
  
`;

export const ImageWrapSmall = styled.div`
  position: relative;
  overflow: hidden;
  ${Helpers.fullWidth};
  z-index: 1;
    height: 150px;
  ${props => props.isClose && css`
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
  `}
  
  &:after {
    content: '';
    width: 100%;
    height: 120px;
    background: linear-gradient(
        1deg
        ,rgba(255,255,255,0.9) 26.79%,rgba(255,255,255,0) 72.32%);
    position: absolute;
    left: 0;
    bottom: 0px;
  }

`;

export const ContentSmallStyle = styled.div`
  background: #FFFFFF;
  ${Helpers.css.flex};
  ${Helpers.css.flex_vertical};
  ${Helpers.css.flex_at};
  ${Helpers.css.flex_grow};
  position: relative;
  z-index: 2;
  padding: 12px;
`;

export const RowtSmallStyle = styled.div`
  ${Helpers.css.flex};
  ${Helpers.css.flex_ac};
  width: 100%;
  margin-bottom: 10px;
`;

export const RowtSmallLeftStyle = styled.div`
`;

export const RowtSmallRightStyle = styled.div`
  margin-left: auto;
`;

export const StickersSmallWrapStyle = styled.div`
  ${Helpers.css.flex};
  ${Helpers.css.flex_reverse};
  ${Helpers.css.flex_ac};
`;

export const BorderStyle = styled.div`
  height: 1px;
  background: #DFDFDF;
  width: 100%;
  margin-bottom: 7px;
`;

export const PartnerWrapStyle = styled.div`
  ${Helpers.css.flex};
  ${Helpers.css.flex_ac};
  position: absolute;
  z-index: 2;
  width: 100%;
  bottom: 0px;
  padding: 8px;
`;

export const PartnerLogoStyle = styled.div`
  width: 15px;
  height: 15px;
  position: relative;
  margin-right: 10px;
  border-radius: 3px;
  overflow: hidden;
`;

export const PartnerNameStyle = styled.div`
  
`;

export const DescStyle = styled.div`
  width: 100%;
`;